module.exports = __webpack_public_path__ + "static/20230619_048-2d1f49b59c6aead6163f38bc90aca0c1.jpg";